/* eslint-disable no-undef */
/* eslint-disable keyword-spacing */
/* eslint-disable no-unused-expressions */
/* eslint-disable space-before-blocks */
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

export default class TimeLine {
  constructor({ htmlBody }) {
    this.htmlBody = htmlBody;
    this.tSlider = this.htmlBody.find('.section__project-timeline__slider');
    this.tLine = this.htmlBody.find('.section__project-progress__footer__timeline');
    this.init();
  }

  init = () => {
    this.tSlider.length && this.slider();
    this.tLine.length && this.timeline();
  };

  slider = () => {
    new Swiper(this.tSlider, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      autoHeight: true,
      grabCursor: true,
      mousewheel: true,
      breakpoints: {
        1023: {
          mousewheel: false,
        }
      }
    });
  }

  timeline = () => {
    const buttons = this.tLine.children();
    buttons.on('click', (e) => {
      e.preventDefault();
      $(e.currentTarget).addClass('active');
      $(e.currentTarget).siblings().removeClass('active');
      $('.section__project-progress__galler').html('<span class="loading-timeline"></div>');
      const url = $(e.currentTarget).attr('href');
      $('.section__project-progress__galler').load(`${url} .section__project-timeline`, () => {
        const s = new Swiper('.section__project-timeline__slider', {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          centeredSlides: true,
          autoHeight: true,
          grabCursor: true,
          mousewheel: true,
          breakpoints: {
            1023: {
              mousewheel: false,
            }
          }
          // navigation: {
          //   nextEl: '.carousel__buttons__btn-next',
          //   prevEl: '.carousel__buttons__btn-prev',
          // },
        });
        $(window).on("resize", function () {
          s.update();
          s.updateSize();
          s.updateSlidesClasses();
        })

      });
    });
    buttons[0].click();
  }
}
